import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { useContext } from 'react';
import { FontsContext } from '@anm/contexts/FontsContext';

var useFontStyles = function useFontStyles() {
  var _useContext = useContext(FontsContext),
      family = _useContext.family;

  var _ref = family || {},
      buttonFontStyles = _ref.button,
      metaFontStyles = _objectWithoutProperties(_ref, ["button"]);

  return [buttonFontStyles, metaFontStyles];
};

export default useFontStyles;